import { Popper, Typography } from '@mui/material'
import { styled } from '@mui/system'
import * as React from 'react'

const Rootdiv = styled('div')({
  height: "50px",
  width: "90vw",
	margin: '10px auto',
})

const PopperDiv = styled(Popper)({
	width: "100vw"
})

const ButtonPreview = styled(Typography)({
	textAlign: 'center',
	display: 'inline-block',
	padding: "0 3px 0 3px",
	fontSize: "18px",
})

export default function PreviewDiv ({anchor, listRef, createButton}) {

	const createArrayButton = React.useCallback((list) => {
		let buttons = [];
		for (const [key, value] of Object.entries(list)){
			buttons.push(createButton(key, value))
			buttons.push(<ButtonPreview key={key + "-"}> - </ButtonPreview>)
		}
		buttons.pop()
		return (buttons)
	}, [createButton])
	const [buttons, setButtons] = React.useState(createArrayButton(listRef))

	React.useEffect(() => {
		setButtons(createArrayButton(listRef))
  }, [listRef, createArrayButton])

  return (
		<PopperDiv open={Boolean(anchor)} anchorEl={anchor}>
				<Rootdiv>
					{buttons}
				</Rootdiv>
		</PopperDiv>
	)
}